import { useQuery } from '@tanstack/react-query';
import { getPaymentSettings } from '@/backend/services/paymentSettings';

export function usePaymentSettings() {
  return useQuery({
    queryKey: ['payment-settings'],
    queryFn: getPaymentSettings,
    staleTime: 5 * 60 * 1000,
  });
}
